export const ar = {
  appName: "أوقات الصلاة",
  tabs: {
    prayer: "الصلاة",
    qiblah: "القبلة",
    masjid: "المسجد",
    settings: "الإعدادات",
    more: "المزيد"
  },
  prayer: {
    nextPrayer: "الصلاة التالية",
    locating: "تحديد موقعك...",
    now: "الآن",
    fajr: "الفجر",
    sunrise: "الشروق",
    dhuhr: "الظهر",
    asr: "العصر",
    maghrib: "المغرب",
    isha: "العشاء",
    loading: "جار التحميل…",
    nextPrayerIn: "الصلاة التالية:",
    in: "في",
    today: "اليوم"
  },
  qiblah: {
    title: "محدد القبلة",
    subtitle: "أدر الجهاز لمحاذاة العلامات",
    compass: "البوصلة",
    direction: "الاتجاه",
    gettingLocation: "جاري الحصول على الموقع…",
    locationPermissionRequired: "إذن الموقع مطلوب.",
    refresh: "تحديث"
  },
  masjid: {
    title: "البحث عن مسجد",
    placeholder: "ابحث بالعنوان أو المدينة...",
    searching: "البحث في خرائط جوجل...",
    viewOnMaps: "عرض في خرائط جوجل",
    noResults: "لم يتم العثور على نتائج قريبة.",
    local: "محلي",
    search: "بحث"
  },
  settings: {
    title: "الإعدادات",
    location: "الموقع",
    manual: "الموقع اليدوي",
    cityCountry: "ابحث عن مدينة...",
    latitude: "خط العرض",
    longitude: "خط الطول",
    calc: "الحساب",
    calcMethod: "طريقة الحساب",
    asrMethod: "طريقة العصر",
    appearance: "المظهر",
    lang: "اللغة",
    theme: "السمة",
    system: "النظام",
    light: "فاتح",
    dark: "مظلم",
    save: "حفظ",
    adhanEnabled: "تفعيل الأذان",
    persistentNotifications: "الإشعارات المستمرة",
    ishaTime: "وقت العشاء",
    fajrTime: "وقت الفجر",
    ishaDefault: "افتراضي",
    fajrDefault: "افتراضي",
    minAfterMaghrib: "دقائق بعد المغرب",
    minBeforeSunrise: "دقائق قبل الشروق",
    minFromIsha: "دقائق من العشاء",
    minFromFajr: "دقائق من الفجر",
    fixedTime: "وقت ثابت",
    prayers: "الصلوات",
    muslimWorldLeague: "رابطة العالم الإسلامي",
    standard: "قياسي"
  },
  more: {
    back: "رجوع",
    tasbih: "التسبيح",
    reset: "إعادة تعيين",
    count: "العد",
    hijri: "التقويم الهجري",
    now: "الآن",
    highlights: "أبرز أحداث الشهر",
    events: "الأحداث والأخبار",
    ramadan: "بداية رمضان",
    eid: "عيد الأضحى",
    duas: "الأدعية اليومية",
    kahf: "سورة الكهف",
    listenFull: "استمع للسورة كاملة",
    pause: "إيقاف",
    stats: "إحصائيات الصلاة",
    statsDesc: "الفترات الزمنية بين نوافذ الصلاة اليومية",
    fajrToMaghrib: "الفجر إلى المغرب",
    dhuhrToAsr: "الظهر إلى العصر",
    sunriseToSunset: "الشروق إلى الغروب",
    fajrToSunrise: "الفجر إلى الشروق",
    maghribToIsha: "المغرب إلى العشاء",
    appInfo: "معلومات التطبيق",
    zakat: "حاسبة الزكاة",
    zakatDesc: "احسب زكاتك (2.5% من الثروة)",
    zakatTotal: "الزكاة المستحقة",
    cashSavings: "النقد / المدخرات",
    goldValue: "قيمة الذهب",
    silverValue: "قيمة الفضة",
    nisabNote: "تأكد من أن ثروتك تصل إلى عتبة النصاب قبل دفع الزكاة",
    inheritance: "حاسبة الميراث",
    inheritanceDesc: "احسب توزيع الميراث الإسلامي",
    estateValue: "قيمة التركة",
    selectHeirs: "اختر الورثة",
    heirHusband: "الزوج",
    heirWife: "الزوجة",
    heirFather: "الأب",
    heirMother: "الأم",
    heirSon: "الابن",
    heirDaughter: "الابنة",
    distribution: "التوزيع",
    share: "نصيب",
    disclaimer: "هذا حساب مبسط. استشر عالماً في الحالات المعقدة.",
    namesOfAllah: "أسماء الله الحسنى",
    nameNumber: "الاسم #",
    spiritualBenefit: "الفائدة الروحية",
    weekDays: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
    monthly: "الأوقات الشهرية",
    halalPlaces: "أماكن حلال",
    trains: "القطارات",
    less: "أقل",
    more: "المزيد...",
    downloadApp: "تحميل تطبيق الجوال",
    adjustHijri: "ضبط التاريخ الهجري",
    hijriCycle: "الدورة الهجرية",
    year: "سنة",
    thisYear: "هذا العام",
    tenYearOverview: "نظرة عامة لـ 10 سنوات",
    ayahs: "آيات",
    ayah: "آية",
    fetchingAyahs: "جاري جلب الآيات...",
    morning: "الصباح",
    evening: "المساء",
    prayerStatistics: "إحصائيات الصلاة",
    prayerIntervals: "فترات أوقات الصلاة",
    daylightHours: "ساعات النهار",
    afternoonPeriod: "فترة بعد الظهر",
    fullDaylight: "ضوء النهار الكامل",
    dawnPeriod: "فترة الفجر",
    eveningPeriod: "فترة المساء",
    errorLoading: "خطأ في تحميل الإحصائيات",
    loadingStats: "جاري تحميل الإحصائيات...",
    sons: "الأبناء",
    daughters: "البنات",
    searchHalal: "ابحث عن أماكن حلال",
    searching: "جاري البحث...",
    noResults: "لم يتم العثور على نتائج",
    viewOnMaps: "عرض على الخريطة",
    selectStation: "اختر المحطة",
    favorites: "المفضلة",
    useCurrentLocation: "استخدم الموقع الحالي",
    refresh: "تحديث",
    loading: "جاري التحميل...",
    dataSource: "البيانات من Liikennevirasto Digital API. مرخصة بموجب Creative Commons Attribution 4.0",
    appVersion: "الإصدار",
    appDescription: "أوقات الصلاة والأدوات الإسلامية لفنلندا"
  },
  trains: {
    useCurrentLocation: "موقعي",
    selectStation: "اختر المحطة",
    noTrainsFound: "لم يتم العثور على قطارات",
    time: "الوقت",
    track: "المسار",
    train: "القطار",
    destination: "الوجهة",
    cancelled: "ملغى"
  },
  ramadan: {
    title: "رمضان 2026",
    expected: "المتوقع:",
    date: "18-19 فبراير",
    daysLeft: "يوم متبقي",
    today: "اليوم!",
    fastingHours: "ساعات الصيام"
  }
};
